export default {
	"title": "Necesito apoyo",
	"image": "Capturas de pantalla",
	"email": "Email",
	"name": "Nombre",
	"placeholder": "Puede describir sus problemas o compartir sus ideas con nosotros aquí",
	"desc": "Sus comentarios serán tratados lo más rápido posible.",
	"submit": "Enviar",
}
